import { render, staticRenderFns } from "./customDashboardPieChart.vue?vue&type=template&id=3a68ec00&scoped=true"
import script from "./customDashboardPieChart.vue?vue&type=script&lang=js"
export * from "./customDashboardPieChart.vue?vue&type=script&lang=js"
import style0 from "./customDashboardPieChart.vue?vue&type=style&index=0&id=3a68ec00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a68ec00",
  null
  
)

export default component.exports